import { BigNumber } from 'ethers';
import { timestampToDate } from './timestampToDate';
import { TimeFrame } from '../hooks/types';

export function formatTimeInterval(time: TimeFrame) {
  const startTime = BigNumber.from(time?.startTime);
  const endTime = BigNumber.from(time?.endTime);

  if (startTime.isZero() || endTime.isZero()) {
    return '-';
  }

  return `${timestampToDate(
    BigNumber.from(time?.startTime).toNumber(),
    true,
  )} - ${timestampToDate(BigNumber.from(time?.endTime).toNumber(), true)}`;
}
